import { Box, Grid, TextField, Tooltip, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CommonUtil from "../../Util/CommonUtils";
import { ThemeContext } from "../../theme/ThemeContext";
import Toast from "../ToastContainer/CustomToast";
import DialogBox from "./DialogBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function SmsTemplateFilterform(props) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [payload, setPayload] = useState({
    recipient: "",
  });

  const recepientOptions = [
    { label: "Host" },
    { label: "Visitor" },
    { label: "Employee" },
  ];

  const handleClose = () => {
    setPayload({
      recipient: "",
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const [error, setError] = useState({
    name: false,
  });

  const handleSubmit = () => {
    if (payload.recipient === "") {
      Toast("Please enter filter condition", "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      recipient: "",
    });
    handleClose();
  };

  useEffect(() => {}, [payload.recipient]);

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setOpen(true)}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <SmsTemplateFilterform />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <SmsTemplateFilterform />
            </FilterIcon>
          )}
        </span>
      </Tooltip>

      <DialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("COMMON006")}
          </span>
        }
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid item xs={12} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              id="combo-box-demo"
              options={recepientOptions}
              value={payload.recipient}
              onChange={(event, value) => {
                if (!CommonUtil.isEmpty(value))
                  setPayload({
                    ...payload,
                    recipient: value.label,
                  });
                else
                  setPayload({
                    ...payload,
                    recipient: "",
                  });
              }}
              // sx={{ width: "100%" , padding :"20px"}}
              renderInput={(params) => (
                <TextField {...params} label="Recepient *" />
              )}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
